<div [class.hidden]="!show">
  <div class="loader-overlay" [ngClass]="isFullPage? 'full-overlay': ''">
    <div *ngIf="show" class="k-i-loading"></div>
  </div>
</div>